// client only


export enum AIStatusType {
	INITIAL = "INITIAL",
	PROGRESS = "PROGRESS",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED"
}
